module.exports = __webpack_public_path__ + "static/media/item_2_6.443bf5bd.png";